import { Flex, Tag } from "antd";
import "./styles/GlowTags.css";

const GlowTags: React.FC = () => {
  return (
    <Flex justify="center" align="center" gap={10}>
      <Tag className="glow-tag glow-tag--volcano" color="volcano" variant="outlined">
        Anne
      </Tag>
      💞💞💞
      <Tag className="glow-tag glow-tag--blue" color="blue" variant="outlined">
        Sachosi
      </Tag>
    </Flex>
  );
};

export default GlowTags;
